import { useState, useEffect } from "react";
import { errorLabels } from "../../../../../utils/helpers";
import { ErrorMessage } from "../../../../../utils/toastify";
import { useFormWebserviceSmry } from "./useFormWebserviceSmry";
import { useFetchWebserviceSmry } from "./useFetchWebserviceSmry";

export const useReportWebservice = () => {
  const { mutate, isPending, data = [] } = useFetchWebserviceSmry();
  const [reset, setReset] = useState(false);
  const formik = useFormWebserviceSmry({
    onSubmit: mutate,
  });

  const _validate = async () => {
    try {
      const isValid = await formik.validateForm();
      const errors = errorLabels(isValid);

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errors}`);
      }
      await formik.submitForm();
    } catch (error) {
      ErrorMessage(error.message);
    }
  };

  const handleReset = () => {
    formik.resetForm();
    setReset(true);
  };

  useEffect(() => {
    if (reset) {
      setReset(false);
    }
  }, [reset]);

  return {
    formik,
    reset,
    isLoading: isPending,
    _validate,
    handleReset,
    data,
  };
};
